// extracted by mini-css-extract-plugin
export default {"ingredientRow":"CookView_ingredientRow__5fNkV","menuButton":"CookView_menuButton__+GA-r"};